// src/components/FindIdPwLayout.tsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import FindIdPwNavigation from './FindIdPwNavigation';
import { NavLink } from 'react-router-dom';

const FindIdPwLayout: React.FC = () => {
  return (
    <section className="flex items-center justify-center min-h-[1100px] bg-white mobile:px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center w-full mb-6">
          <NavLink to="/">
            <img
              src={`${process.env.PUBLIC_URL}/logo/logo.png`}
              alt="Creator Store"
              className="h-auto object-cover"
            />
          </NavLink>
        </div>

        <div className="flex flex-col">
          <h1 className="font-medium text-[#747474] text-base text-center mb-10">
            아이디 / 비밀번호 찾기
          </h1>

          {/* Navigation */}
          <FindIdPwNavigation />

          {/* Content */}
          <Outlet />
        </div>
      </div>
    </section>
  );
};

export default FindIdPwLayout;
